function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React from "react";
import { Picture, Source, Img } from "@xo-union/tk-component-picture";
import LinkAgent from "./LinkAgent.js";
import { isMobile } from "../../utils/platform.js";
import styles from "./styles.css";
import { useTrack } from "@tkww/ads-content-component-analytics/react";
import getTrackingData from "../../data/index.js";
var LocalFinder = function LocalFinder(_ref) {
  var infos = _ref.infos;
  var _React$useState = React.useState(infos["mobile"]["img_id"]),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    imageId = _React$useState2[0],
    setImageId = _React$useState2[1];
  var mobileImg = infos["mobile"]["img_id"];
  var desktopImg = infos["desktop"]["img_id"];
  var alt = isMobile() ? infos["mobile"]["img_alt"] : infos["desktop"]["img_alt"];
  var trackingData = getTrackingData("clickThroughToWebsite");
  var _useTrack = useTrack(trackingData === null || trackingData === void 0 ? void 0 : trackingData.name, trackingData === null || trackingData === void 0 ? void 0 : trackingData.data),
    track = _useTrack.track;
  React.useEffect(function () {
    var handleResize = function handleResize() {
      if (window.innerWidth < 768) {
        setImageId(mobileImg);
      } else {
        setImageId(desktopImg);
      }
    };

    // Set the initial image
    handleResize();

    // Add resize listener
    window.addEventListener("resize", handleResize);

    // Cleanup event listener on unmount
    return function () {
      window.removeEventListener("resize", handleResize);
    };
  }, [mobileImg, desktopImg]);
  var handleClick = function handleClick(e) {
    var defaultParams = JSON.parse(e.target.getAttribute("data-analytics"));
    if (defaultParams) track(defaultParams);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: styles["local-store-finder-section"]
  }, /*#__PURE__*/React.createElement("div", {
    className: styles["local-store-text"]
  }, /*#__PURE__*/React.createElement("div", {
    className: styles["local-store-heading"]
  }, "See Your Dream Dress?"), /*#__PURE__*/React.createElement("div", {
    className: styles["local-store-description"]
  }, "Try it on at a nearby salon."), /*#__PURE__*/React.createElement("div", {
    className: styles["local-store-button"]
  }, /*#__PURE__*/React.createElement(LinkAgent, {
    "data-analytics": "{\"selection\": \"Find Your Salon\", \"userDecisionArea\": \"Local store finder section\"}",
    linkText: "Find Your Salon",
    classes: "local-store-finder-btn",
    color: "primary",
    href: infos["linking_url"],
    target: "_blank",
    rel: "nofollow",
    "data-testid": "local-store-finder-btn",
    onClick: handleClick
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles["local-store-image"]
  }, /*#__PURE__*/React.createElement(Picture, {
    pixelDensities: [1, 2],
    lazy: true,
    env: "production"
  }, /*#__PURE__*/React.createElement(Source, {
    viewport: "lg",
    id: desktopImg,
    width: 900
  }), /*#__PURE__*/React.createElement(Source, {
    viewport: "md",
    id: desktopImg,
    width: 768
  }), /*#__PURE__*/React.createElement(Source, {
    viewport: "xs",
    id: mobileImg,
    width: 480
  }), /*#__PURE__*/React.createElement(Img, {
    className: styles["right-image"],
    id: imageId,
    width: 480,
    alt: infos["img_alt"] || alt
  })), infos["photo_credit"] && /*#__PURE__*/React.createElement("span", {
    className: styles["store-photo-credit"]
  }, infos["photo_credit"])));
};
export default LocalFinder;